<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 28 28" fill="none">
    <path d="M20.9628 8.26534C20.9628 8.94395 20.4126 9.49407 19.734 9.49407C19.3856 9.49407 19.0711 9.34906 18.8475 9.11611C18.7526 9.01723 18.628 8.94518 18.4909 8.94518H9.50906C9.372 8.94518 9.24743 9.01723 9.15251 9.11611C8.9289 9.34906 8.61437 9.49407 8.26596 9.49407C7.58736 9.49407 7.03724 8.94395 7.03724 8.26534C7.03724 7.58674 7.58736 7.03662 8.26596 7.03662C8.61428 7.03662 8.92875 7.18156 9.15235 7.41441C9.24726 7.51325 9.3718 7.58526 9.50883 7.58526L18.4912 7.58526C18.6282 7.58526 18.7527 7.51325 18.8477 7.41441C19.0713 7.18156 19.3857 7.03662 19.734 7.03662C20.4126 7.03662 20.9628 7.58674 20.9628 8.26534Z" 
    fill="url(#paint_linear_data_api)"/>
    <path d="M20.9627 13.9994C20.9627 14.678 20.4126 15.2281 19.734 15.2281C19.0554 15.2281 18.5053 14.678 18.5053 13.9994C18.5053 13.3208 19.0554 12.7707 19.734 12.7707C20.4126 12.7707 20.9627 13.3208 20.9627 13.9994Z" 
    fill="url(#paint_linear_data_api)"/>
    <path d="M8.26596 20.9622C8.94457 20.9622 9.49469 20.412 9.49469 19.7334C9.49469 19.0548 8.94457 18.5047 8.26596 18.5047C7.58736 18.5047 7.03724 19.0548 7.03724 19.7334C7.03724 20.412 7.58736 20.9622 8.26596 20.9622Z" 
    fill="url(#paint_linear_data_api)"/>
    <path d="M14 20.9622C14.6786 20.9622 15.2287 20.412 15.2287 19.7334C15.2287 19.0548 14.6786 18.5047 14 18.5047C13.3214 18.5047 12.7713 19.0548 12.7713 19.7334C12.7713 20.412 13.3214 20.9622 14 20.9622Z" 
    fill="url(#paint_linear_data_api)"/>
    <path d="M19.734 20.9622C20.4126 20.9622 20.9627 20.412 20.9627 19.7334C20.9627 19.0548 20.4126 18.5047 19.734 18.5047C19.0554 18.5047 18.5053 19.0548 18.5053 19.7334C18.5053 20.412 19.0554 20.9622 19.734 20.9622Z" 
    fill="url(#paint_linear_data_api)"/>
    <path d="M14 15.2281C14.6786 15.2281 15.2287 14.678 15.2287 13.9994C15.2287 13.3208 14.6786 12.7707 14 12.7707C13.6517 12.7707 13.3372 12.9156 13.1136 13.1485C13.0187 13.2473 12.8942 13.3193 12.7572 13.3193H9.50885C9.37182 13.3193 9.24728 13.2473 9.15237 13.1485C8.92877 12.9156 8.6143 12.7707 8.26598 12.7707C7.58738 12.7707 7.03726 13.3208 7.03726 13.9994C7.03726 14.678 7.58738 15.2281 8.26598 15.2281C8.61439 15.2281 8.92892 15.0831 9.15253 14.8502C9.24745 14.7513 9.37202 14.6792 9.50908 14.6792H12.7569C12.894 14.6792 13.0186 14.7513 13.1135 14.8502C13.3371 15.0831 13.6516 15.2281 14 15.2281Z" 
    fill="url(#paint_linear_data_api)"/>
    <defs>
      <linearGradient id="paint_linear_data_api" x1="14" y1="7.03662" x2="14" y2="20.9622" gradientUnits="userSpaceOnUse">
        <stop stop-color="currentColor"/>
        <stop offset="1" stop-color="currentColor" stop-opacity="0.68"/>
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'DataApiIcon',
  props: {
    width: {
      type: Number,
      default: 28
    },
    height: {
      type: Number,
      default: 28
    }
  }
}
</script>

<style scoped></style>